module.exports = __webpack_public_path__ + "static/media/code-green-bg.3679fd98.png";